import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { MARKETING_ROUTES } from './site/marketingRoutes'
import SmsOptIn from './pages/SmsOptIn'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import MasterServicesAgreement from './pages/MasterServicesAgreement'
import DataProcessingAgreement from './pages/DataProcessingAgreement'
import AcceptableUsePolicy from './pages/AcceptableUsePolicy'
import Subprocessors from './pages/Subprocessors'
import Accessibility from './pages/Accessibility'
import AiDisclosure from './pages/AiDisclosure'
import ReceiptDashboard from './pages/ReceiptDashboard'
import DigitalReceipt from './pages/Digitalreceipts'
import DriverView from './pages/DriverView'
import ReviewPage from './ReviewPage'
import BrandAdminPage from './pages/BrandAdminPage'

// The furniture platform moved back to the home page (2026-10-29); old
// links like /furniture#pricing keep their hash.
function FurnitureRedirect() {
  const { hash } = useLocation();
  return <Navigate to={`/${hash}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main landing page.
            The previous one is still on disk as pages/EdictLabsWebsite.jsx,
            unreferenced, so a rollback is a one-line import swap. It is not
            bundled while nothing imports it. */}
        {MARKETING_ROUTES.map((r) => <Route key={r.path} path={r.path} element={r.element} />)}

        {/* Old product page address */}
        <Route path="/ai-phone-agents" element={<Navigate to="/phone-agent" replace />} />
        <Route path="/furniture" element={<FurnitureRedirect />} />

        {/* Core app routes */}
        <Route path="/dashboard" element={<ReceiptDashboard />} />
        <Route path="/receipt/:receiptId" element={<DigitalReceipt />} />
        <Route path="/driver/:routeId" element={<DriverView />} />
        <Route path="/review" element={<ReviewPage />} />

        {/* Exitium admin: which manufacturer brands each store carries.
            Gated by login email in the store-brands API. */}
        <Route path="/admin/brands" element={<BrandAdminPage />} />

        {/* Legal & compliance */}
        <Route path="/sms-opt-in" element={<SmsOptIn />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/legal/msa" element={<MasterServicesAgreement />} />
        <Route path="/legal/dpa" element={<DataProcessingAgreement />} />
        <Route path="/legal/aup" element={<AcceptableUsePolicy />} />
        <Route path="/legal/subprocessors" element={<Subprocessors />} />
        <Route path="/legal/accessibility" element={<Accessibility />} />
        <Route path="/legal/ai-disclosure" element={<AiDisclosure />} />

        {/* Redirect old routes to home */}
        <Route path="/ai_services" element={<Navigate to="/" replace />} />
        <Route path="/websites" element={<Navigate to="/website" replace />} />
        <Route path="/digital_marketing" element={<Navigate to="/" replace />} />

        {/* Anything unmatched goes home. Without this an unknown path renders
            an empty page, since Vercel rewrites everything to index.html and
            the router then matches nothing — /preview included, now that it's
            gone. Static files and /api/* are resolved before this ever runs. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
